import { Decimal } from 'decimal.js-light';
import React from 'react';
import { FormattedNumber } from 'src/modules/common/components/FormattedNumber';

type Props = {
  readonly value: Decimal | null;
  readonly precision: number;
};

export const FormattedValue = ({ value, precision }: Props): React.ReactElement => {
  if (value === null) {
    return <>&mdash;</>;
  }

  return (
    <FormattedNumber
      value={value.toDecimalPlaces(precision)}
      minimumFractionDigits={precision}
      maximumFractionDigits={precision}
    />
  );
};
